// types
import { ReviewedCart } from "@cart-client/interfaces/Cart";
import { NativeLocalCart } from "@swiggy-private/cart-types";

// helpers
import { mergePaymentCouponToLocalCart, unmergeCouponsFromLocalCart } from "./helpers";

export const useLocalCartTransformer = () => {
    const transformLocalCart = (localCart: NativeLocalCart, reviewedCart: ReviewedCart | null) => {
        return mergePaymentCouponToLocalCart(localCart, reviewedCart);
    };

    const prepareLocalCartForUpdateCartPayload = (localCart: NativeLocalCart) => {
        return unmergeCouponsFromLocalCart(localCart);
    };

    return {
        transformLocalCart,
        prepareLocalCartForUpdateCartPayload,
    };
};
